import React, { useState, useEffect } from 'react';
import ContentPage from '../components/ContentPage';
import { clientApi } from '../lib/api';

const formatPrice = (n) => `${Number(n || 0).toFixed(0)} €`;

export default function TarifsPage() {
  const [pricing, setPricing] = useState({ formulas: [] });

  useEffect(() => {
    clientApi.getPricing().then((res) => setPricing(res.data || { formulas: [] })).catch(() => setPricing({ formulas: [] }));
  }, []);

  return (
    <ContentPage
      pageId="tarifs"
      relatedLinks={[
        { to: '/services-a-la-personne', label: 'Découvrir le crédit d\u2019impôt de 50 %' },
        { to: '/comment-ca-marche', label: 'Découvrir comment fonctionne Mitonner' },
        { to: '/menus', label: 'Voir les menus' },
      ]}
    >
      <div data-testid="tarifs-dynamic" className="grid sm:grid-cols-3 gap-4 mb-4">
        {(pricing.formulas || []).map((f) => (
          <div key={f.key} className="bg-white rounded-2xl border border-[#E3DED5] p-6 flex flex-col" data-testid={`tarif-${f.key}`}>
            <h2 className="font-['Cormorant_Garamond'] text-2xl font-semibold text-[#2A312C]">{f.name}</h2>
            {f.description && <p className="text-sm text-[#5C6A61] mt-1">{f.description}</p>}
            <p className="text-3xl font-semibold text-[#2A312C] mt-4">{formatPrice(f.price)}</p>
            <p className="text-sm text-[#A5BBA8] font-medium mt-1">soit {formatPrice(f.price / 2)} après crédit d’impôt de 50 %</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-[#5C6A61] mb-4">
        Les prestations de préparation de repas à domicile sont éligibles au crédit d’impôt de 50 % au titre des services à la personne, selon la réglementation en vigueur.
      </p>
    </ContentPage>
  );
}
